// extracted by mini-css-extract-plugin
export default {"wrapper":"u4YP4","clipboard":"d0rC7","icon":"hUQ9i","confirm":"W0KKr"};